import { render, staticRenderFns } from "./AllResultsCard.vue?vue&type=template&id=c3611b48&scoped=true&"
import script from "./AllResultsCard.vue?vue&type=script&lang=js&"
export * from "./AllResultsCard.vue?vue&type=script&lang=js&"
import style0 from "./AllResultsCard.vue?vue&type=style&index=0&id=c3611b48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3611b48",
  null
  
)

export default component.exports